import { render, staticRenderFns } from "./ProductPricePC.vue?vue&type=template&id=d01d20cc&scoped=true"
import script from "./ProductPricePC.vue?vue&type=script&lang=js"
export * from "./ProductPricePC.vue?vue&type=script&lang=js"
import style0 from "./ProductPricePC.vue?vue&type=style&index=0&id=d01d20cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01d20cc",
  null
  
)

export default component.exports